import { useState, useEffect } from 'react';
import { StoreReviewsPage } from './store/StoreReviewsPage';
import { DesktopConsumerStoreReviewsPage } from './desktop/DesktopConsumerStoreReviewsPage';

/**
 * 구매자용 반응형 리뷰 페이지
 * 화면 크기에 따라 모바일/데스크톱 뷰를 자동 전환
 * 단일책임: 구매자의 리뷰 열람을 위한 반응형 뷰 제공
 */
export function ResponsiveConsumerStoreReviewsPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // 모바일: 기존 StoreReviewsPage 사용
  // 데스크톱: 새로운 DesktopConsumerStoreReviewsPage 사용
  return isMobile ? <StoreReviewsPage /> : <DesktopConsumerStoreReviewsPage />;
}